export type CurrencySelectSettings = {
  includeBlank: boolean;
  investedOnly: boolean;
};

export const defaultCurrencySelectSettings: CurrencySelectSettings = {
  includeBlank: false,
  investedOnly: false,
};
